import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Tooltip, Fab } from '@mui/material';
import { ParentSize } from '@visx/responsive';
import DonutIcon from '@mui/icons-material/DonutLarge';
import ListIcon from '@mui/icons-material/FormatListBulletedRounded';
import GraphsLegend from './Charts/GraphsLegend';
import DonutChart from './Charts/DonutChart';
import { useAtomValue } from 'jotai';
import { themeAtom } from '../Atoms';

/**Sums provided array of objects properties **/
const propertySum = (sourceArray, propertyName) =>
  sourceArray?.reduce((acc, curr) => acc + curr[propertyName], 0);
/****/

const CallStatsDonutChart = function CallStatsDonutChart({
  stats = {},
  tabValue = '',
  outcomes = [],
}) {
  const intl = useIntl();
  const theme = useAtomValue(themeAtom);
  const [showLegend, setShowLegend] = useState(false);

  const toggleChartView = () => {
    setShowLegend(!showLegend);
  };

  return (
    <>
      {showLegend ? (
        <GraphsLegend
          legendData={stats?.legend?.data}
          legendColor={stats?.legend?.colors?.map((x) => x[theme])}
        />
      ) : (
        <ParentSize
          style={{
            flexGrow: 1,
          }}
        >
          {({ width, height }) => (
            //parent component passes his css properties to DonutChart
            <DonutChart
              themeMode={theme}
              width={width || 400}
              height={height || 400}
              halfSize={width / 2}
              dataToShow={stats?.donut}
              outcomes={outcomes}
              total={propertySum(stats?.donut, 'value')}
              text={
                stats?.text ??
                (tabValue && (intl.messages[tabValue] || tabValue))
              }
              alternativeTexts={
                stats?.alternativeTexts !== undefined
                  ? stats?.alternativeTexts
                  : []
              }
            />
          )}
        </ParentSize>
      )}
      <Tooltip
        title={showLegend ? intl.messages.SHOW_CHART : intl.messages.SHOW_LIST}
        placement="top"
      >
        <Fab
          id="change-view-fab"
          sx={{ position: 'absolute', bottom: 30, right: 30 }}
          color="primary"
          size="small"
          aria-label="change data display"
          onClick={toggleChartView}
        >
          {showLegend ? <DonutIcon /> : <ListIcon />}
        </Fab>
      </Tooltip>
    </>
  );
};

CallStatsDonutChart.propTypes = {
  stats: PropTypes.object,
  tabValue: PropTypes.string,
  outcomes: PropTypes.array,
};

export default CallStatsDonutChart;
